import {Component, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from "../../../../services/header/header.service";
import feather from "feather-icons";
import {ResetStockComponent} from "../gestionStock/reset-stock/reset-stock.component";
import {DetailInventaireComponent} from "./detail-inventaire/detail-inventaire.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-inventaire',
  templateUrl: './inventaire.component.html',
  styleUrls: ['./inventaire.component.scss']
})
export class InventaireComponent implements OnInit {


  ngAfterViewInit() {
    feather.replace();
  }
    items  = [
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Créé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Valide'
        },

        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Créé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Créé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            clientEmail: 'Layne_Kuvalis@gmail.com',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Annulé'
        },
        {
            reference: 'BS-0009',
            date: '10/04/2025',
            clientName: 'Aymen',
            totalTTC: '300,600 TND',
            totalTTCNoSpace: '300,600TND',
            status: 'Valide'
        }
    ];
  selectedStatus: string = 'Tous';
  filteredItems: any[] = [];
  showFilter = false;
  filters = {
    client: '',
    projet: '',
    montant: '',
    etat: '',
    point_vente: ''
  };


  constructor(private headerService: HeaderService, private router : Router) { }
  searchText = '';
  currentPage = 1;



  ngOnInit(): void {

    this.headerService.setConfig({
      title: 'Inventaire',
      buttons: [
        {
          label: 'Exporter',
          action: () => this.exportData(),
          type: 'secondary'
        },
        {
          label: 'Importer',
          action: () => this.openAddModal(),
          type: 'secondary'
        }
      ]
    });


  }

  exportData() {
    console.log('Exporting data...');
  }

  openAddModal() {
    console.log('Opening modal...');
  }






}
